type WindowWithDataLayer = Window & {
  dataLayer: PushToDataLayerProps[];
};

declare const window: WindowWithDataLayer;

export interface PushToDataLayerProps {
  event?: string;
  flow?: string;
  location?: string;
  text?: string;
  section?: string;
  opcao_selecionada?: string;
  opcao_selecionada_1?: string;
  id_anunciante?: number;
  feedback?: string;
}

export function pushToDataLayer(options: PushToDataLayerProps): void {
  window.dataLayer.push(options);
}

export function pushSellerPFDashboardEvent(
  text: string,
  section = 'lista de anúncio',
  args?: Omit<PushToDataLayerProps, 'flow' | 'text' | 'section'>
): void {
  pushToDataLayer({
    event: args?.event || 'navigation_click',
    flow: 'seller_pf',
    location: args?.location || 'meus anúncios',
    text,
    section,
    ...args
  });
}
